import { Alert } from '@cmsgov/design-system';

export interface ApprovalReturnFeedbackBannerProps {
  returnFeedback?: {
    fieldIssues?: Array<{
      fieldPath?: string;
      fieldLabel?: string;
      message?: string;
      currentValue?: string | number | boolean | null;
    }>;
    generalNotes?: string;
  } | null;
}

export function ApprovalReturnFeedbackBanner({ returnFeedback }: ApprovalReturnFeedbackBannerProps) {
  if (!returnFeedback) {
    return null;
  }

  // The COR re-reviews the WHOLE application after a VAS return (the applicant's
  // corrections included), so every issue VAS raised is shown — not just the
  // COR-owned slice. Applicant-side redaction happens server-side for the
  // contractor audience; this banner only ever renders for reviewers.
  const { fieldIssues = [], generalNotes } = returnFeedback;

  if (fieldIssues.length === 0 && !generalNotes) {
    return null;
  }

  return (
    <div
      className='approval-details-page__return-feedback-banner'
      data-testid='approval-details-return-feedback-banner'>
      <Alert
        heading='Application Returned for Edits'
        variation='error'>
        <p>The following issues were flagged by the reviewer and must be addressed before re-approving:</p>

        {fieldIssues.length > 0 && (
          <ul className='approval-details-page__return-feedback-list'>
            {fieldIssues.map((issue, index) => (
              <li
                key={`${issue.fieldPath ?? issue.fieldLabel ?? index}`}
                className='approval-details-page__return-feedback-item'>
                <strong>{issue.fieldLabel ?? issue.fieldPath}</strong>
                {issue.currentValue !== undefined &&
                  issue.currentValue !== null &&
                  String(issue.currentValue).trim() !== '' && (
                    <span> (Current value: {String(issue.currentValue)})</span>
                  )}
                <br />
                <span>{issue.message ?? ''}</span>
              </li>
            ))}
          </ul>
        )}

        {generalNotes && (
          <div className='approval-details-page__return-feedback-notes'>
            <strong>General Notes:</strong>
            <p className='ds-u-margin-bottom--0'>{generalNotes}</p>
          </div>
        )}
      </Alert>
    </div>
  );
}
